import {Badge} from "@/components/ui/badge";
import {cn} from "@/lib/utils";

import {Shift} from "../types";

interface StatusBadge {
  shift: Shift;
}

export const STATUS_MAP = {
  unscheduled: "unpublish",
  scheduled: "published",
};

const STATUS_BADGE_VARIANTS = {
  unscheduled: "warning",
  scheduled: "secondary",
  active: "info",
  completed: "success",
  cancelled: "error",
  no_show: "danger",
} as const;

export function StatusBadge({shift}: StatusBadge) {
  const status = shift.status.replace(/_/g, " ");
  const statusText = STATUS_MAP[status as keyof typeof STATUS_MAP] ?? status;

  const variant = STATUS_BADGE_VARIANTS[shift.status as keyof typeof STATUS_BADGE_VARIANTS];
  return (
    <Badge variant={variant} className={cn("capitalize")}>
      {statusText}
    </Badge>
  );
}
